import React from "react";
import styled, { css } from "styled-components";

export const Frame = styled.div`
	background-color: #ccc;
	position: relative;
	border-radius: 14px;
	overflow: hidden;
	${(props) =>
		props.onClick != undefined &&
		css`
			cursor: pointer;
		`}
`;
export const Img = styled.img``;
export const ArrowTopLeft = styled.svg`
	position: absolute;
	top: -38px;
	left: -38px;
`;
export const ArrowTopRight = styled.svg`
	display: block;
	position: absolute;
	top: -38px;
	right: -38px;
`;
export const ArrowBottomLeft = styled.svg`
	position: absolute;
	bottom: -38px;
	left: -38px;
`;
export const ArrowBottomRight = styled.svg`
	position: absolute;
	bottom: -38px;
	right: -38px;
`;
export const Focus = styled.svg`
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
`;
